export default __webpack_public_path__ + "static/media/CONFIRM_LOADING_THE_CONTAINER.119e0200.svg";